module.exports = __webpack_public_path__ + "static/button-top-78189297eee1b90bb8b24d4c55818d5a.png";